// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1tbgu","image":"Header_image__3M3YH","name":"Header_name__1fYSl","info":"Header_info__22MDd","infoRow":"Header_infoRow__1y2lx"};